<template>
  <ion-page>
    <master-layout pageTitle="درخواست های تامین کالا">
          <Loading :is="!pageLoaded" v-if="!pageLoaded"></Loading>
          <div v-if="pageLoaded">
            <div v-if="page">
              <div v-if="confirmPreOrders.length">
                <ion-card>
                  <h4>سفارشات تایید شده</h4>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>شماره سفارش</th>
                        <th>تاریخ ثبت</th>
                        <th>زمان باقی مانده برای ثبت سفارش</th>
                        <th>جزئیات</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in confirmPreOrders" :key="index">
                        <td>{{item.order_number}}</td>
                        <td>{{item.created_date}}</td>
                        <td class="text-danger"><timer :number="item.expire_time"></timer></td>
                        <td>
                          <router-link :to="'preOrder/Info/'+item._id">
                          <ion-button color="secondary"><i class="far fa-info-circle"></i></ion-button>
                          </router-link>
                          <ion-button @click="deletePreOrder(item._id)" color="danger"><i class="far fa-trash"></i></ion-button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </ion-card>
              </div>
              <div v-if="waitingPreOrders.length">
                <ion-card class="p-2">
                  <h4>درخواست های درانتظار بررسی</h4>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>شماره سفارش</th>
                        <th>تاریخ ثبت</th>
                        <th>جزئیات</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in waitingPreOrders" :key="index">
                        <td>{{item.order_number}}</td>
                        <td>{{item.created_date}}</td>
                        <td>
                          <router-link :to="'preOrder/Info/'+item._id">
                            <ion-button color="secondary"><i class="far fa-info-circle"></i></ion-button>
                          </router-link>
                          <ion-button @click="deletePreOrder(item._id)" color="danger"><i class="far fa-trash"></i></ion-button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </ion-card>
              </div>
              <div v-if="cancelPreOrders.length">
                <ion-card>
                  <h4>درخواست های لغو شده</h4>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>شماره سفارش</th>
                        <th>تاریخ ثبت</th>
                        <th>جزئیات</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in cancelPreOrders" :key="index">
                        <td>{{item.order_number}}</td>
                        <td>{{item.created_date}}</td>
                        <td>
                          <router-link :to="'preOrder/Info/'+item._id">
                            <ion-button color="secondary"><i class="far fa-info-circle"></i></ion-button>
                          </router-link>
                          <ion-button @click="deletePreOrder(item._id)" color="danger"><i class="far fa-trash"></i></ion-button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </ion-card>
              </div>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage, IonCard, IonCardContent, IonCardHeader, alertController} from '@ionic/vue';
import Timer from "@/components/Timer";
import {showSystemNoti} from "@/shared/helper";
// import {getFormData} from '@/shared/helper'

export default {
  components: {
    Timer,
    IonPage, IonCard, IonCardContent, IonCardHeader
  },
  data()
  {
    return {
      id: null,
      pageLoaded: false,
      page: null,
      error: null,
      waitingPreOrders : [],
      confirmPreOrders : [],
      cancelPreOrders : [],
    }
  },
  async created()
  {
    await this.init();
  },
  methods: {
    ...mapActions("app", {

    }),
    ...mapActions("shop", {
      getPreOrders: 'getPreOrders',
      deletePreOrderFunc : 'deletePreOrder'
    }),
    async init()
    {
      this.pageLoaded = false;
      this.page = false;
      this.error = false;
      this.waitingPreOrders = [];
      this.confirmPreOrders = [];
      this.cancelPreOrders = [];
      const check = await this.getPreOrders();
      if (!check)
      {
        this.pageLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
      else
      {
        if (check.ok)
        {
          this.pageLoaded = true;
          this.page = true;
          this.waitingPreOrders = check.waitingPreOrders;
          this.confirmPreOrders = check.confirmPreOrders;
          this.cancelPreOrders = check.cancelPreOrders;
        }
        else
        {
          this.pageLoaded = true;
          this.error = check.error;
        }
      }
    },
    async deletePreOrder(id)
    {
      const self = this;
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'درخواست تامین کالا حذف شود.',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const check = await this.deletePreOrderFunc(id);
                  if (check.ok)
                  {
                    return showSystemNoti('success',check.message,function (){
                      self.init();
                    });
                  }
                  else
                    return showSystemNoti('success',check.error);
                },
              },
            ],
          });
      return alert.present();
    },
    watch: {
      "$route.path": {
        handler(newUrl)
        {
          if (newUrl.toLowerCase().indexOf('shop/preorderlist') >= 0)
          {
            this.init()
          }
        },
        deep:true
      },
    }
  }
}

</script>

<style scoped>
.p-2
{
  padding: 5px;
}
</style>